export default "__VITE_ASSET__DZW7Xwtt__"